import Vue from 'vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import { MdField } from 'vue-material/dist/components'
Vue.use(VueMaterial)

import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'
Vue.use(VueToast)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import VueMaterialSlider from 'vue-material-slider'
import 'vue-material-slider/dist/vue-material-slider.css'
Vue.use(VueMaterialSlider)

import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
    config: { id: 'G-PVHZLDXVR0' }
})

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

/* hack to fix mdselect error with validation */
Vue.use(MdField)
Vue.component(
    'MdSelect',
    Vue.options.components.MdSelect.extend({
        methods: {
            isInvalidValue: function isInvalidValue() {
                return this.$el.validity
                    ? this.$el.validity.badInput
                    : this.$el.querySelector('input').validity.badInput
            }
        }
    })
)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.config.errorHandler = (err) => {
    if (process.env.NODE_ENV !== 'production') {
        // Show any error but this one
        var error_mesages = [
            "Cannot read properties of undefined (reading 'badInput')",
            "Cannot read property 'badInput' of undefined"
        ]
        for (var error in error_mesages) {
            if (err.message != error_mesages[error]) {
                console.log(err)
            }
        }
    }
}

import ca from '@assets/languages/ca.json'
import en from '@assets/languages/en.json'
import es from '@assets/languages/es.json'

const messages = {
    ca: ca,
    en: en,
    es: es
}

const dateTimeFormats = {
    en: {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: false
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        }
    },
    es: {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: false
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric',
            hour12: false
        }
    },
    ca: {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: false
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric',
            hour12: false
        }
    }
}

let navigator_language = navigator.language || navigator.userLanguage
if (navigator_language.indexOf('-')) {
    navigator_language = navigator_language.split('-')[0]
}
// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: navigator_language, // set locale
    fallbackLocale: 'en',
    dateTimeFormats, // Date formats
    messages // set locale messages
})

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App)
}).$mount('#app')
